define([
    "jquery",
    "underscore",
    "marionette",
    "google_analytics",
    "forms/deposit/deposit_local_payment_form",
    "behaviors/form_errors_behavior"
], function($, _, Marionette, GoogleAnalytics, LocalPaymentForm, FormErrorsBehavior) {

    let eventTimer;

    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        ui: {
            uTransferModal: '#local_payment_modal',
            submitButton: '#deposit_btn',
            cancelButton: '#cancel-deposit-btn',
            uTransferKYCButton: '#ut-kyc-btn',
            krwAmountInput: '#amount',
            spanErrorAmount: '#error_amount'
        },

        events: {
            'click @ui.submitButton': 'submitForm',
            'click @ui.cancelButton': 'requestCancelDeposit',
            'click @ui.uTransferKYCButton': 'openUtransferUrl',
            'keyup @ui.krwAmountInput': 'requestKrwToUsd',
        },

        initialize: function(){
            this.bindUIElements();
            this.initIFrameMessageListener();

            if(window.lang === 'ko_KR')
            {
                GoogleAnalytics.sendGaPageviewEvent(GoogleAnalytics.googleAnalyticsUrls.local_payment_open_kr);
            }

            $('#utransfer-iframe').load(function() {
                if(window.is_iframe)
                {
                    if(window.iframe_url.includes('temp_token'))
                    {
                        GoogleAnalytics.sendGaPageviewEvent(GoogleAnalytics.googleAnalyticsUrls.local_payment_subscriber_pageout_kr);
                    }
                    else
                    {
                        GoogleAnalytics.sendGaPageviewEvent(GoogleAnalytics.googleAnalyticsUrls.local_payment_unsubscribed_open_kr);
                    }

                    $('#local_payment_modal').modal('show');
                }
            });
        },

        initIFrameMessageListener: function() {
            window.addEventListener('message', function (event) {
                // Check the origin of the data!
                // Use only data from trusted origins
                if (event.origin.indexOf('utransfer') > 0 || event.origin.indexOf('175') > 0)
                {
                    // Data sent with postMessage is stored in event.data
                    // It is only used when the closing signal is given by the utransfer side.
                    // Don't know when it will be blocked by Google security policy
                    if (event.data === "close") {

                        if(window.is_iframe && !window.iframe_url.includes('temp_token'))
                        {
                            $('#local_payment_modal').modal('hide');
                        }
                        else
                        {
                            $('#deposit_btn').attr('disabled', true);
                            $('#local_payment_modal').modal('hide');
                            location.reload();
                        }
                    }
                }
                return false;
            });
        },

        submitForm: function(e) {
            e.preventDefault();

            this.triggerMethod('hide:errors');

            var formData = Backbone.Syphon.serialize(this.$('#form_submit')[0]);
            const form = new LocalPaymentForm();
            form.set(formData)

            const errors = form.validate();
            const that = this;
            if(_.size(errors) < 1)
            {
                form.validateWithServer({
                    type: 'POST',
                    success: function(model, res){
                        if(window.is_iframe && !window.iframe_url.includes('temp_token'))
                        {
                            $('#local_payment_modal').modal('show');
                        }
                        else
                        {
                            that.requestSubmitDeposit(that);
                        }
                    },
                    error: function(model, error){
                        that.triggerMethod('show:errors', error.responseJSON);
                    }
                });
            }
            else {
                this.triggerMethod('show:errors', errors);
            }
        },

        requestSubmitDeposit: function(that) {
            const form = $('#form_submit');
            $.ajax({
                url: form.attr('action'),
                type: 'POST',
                data: {
                    mt4_account_no: $('#mt4_account_no').val(),
                    currency_abbr: $('#currency_abbr').val(),
                    amount: $('#amount').val(),
                },
                dataType: 'json',
                success: function(data) {
                    if(data == 'Moved Permanently' || data['success'] == false)
                    {
                        location.reload();
                        return;
                    }
                    $('#utransfer-iframe').attr('src', data.data.url);
                    $('#local_payment_modal').modal('show');
                },
                error: function(data, status, errors) {
                    if(errors == 'Moved Permanently' || errors['success'] == false)
                    {
                        location.reload();
                        return;
                    }
                    that.triggerMethod('show:errors', errors);
                }
            });
        },

        requestCancelDeposit: function(e) {
            e.preventDefault();

            const transactionId = $('#cancel-deposit-btn').data('transactionid');
            $.ajax({
                url: '/rest_deposit/local_payment_cancel',
                type: 'POST',
                dataType: 'json',
                data: {
                    transactionId
                },
                success: function(data) {
                    location.reload();
                },
                error: function(data, status, errors) {
                    if(errors === 'Moved Permanently' || errors['success'] === false)
                    {
                        location.reload();
                        return;
                    }
                }
            });
        },

        requestKrwToUsd: function(e) {
            if(this.timer) {
                clearTimeout(this.timer)
            }
            this.timer = setTimeout(function () {
                const krw = $('#amount').val();
                if (isNaN(krw) || krw === '' || !krw) {
                    $('#amount-usd').val('-');
                    return;
                }

                $.ajax({
                    url: `/rest_deposit/local_payment_deposit_rate?krw=${krw}`,
                    type: 'GET',
                    success: function (data) {
                        if (!data.deposit_rate.success)
                        {
                            if(krw < 50000)
                            {
                                $('#amount-usd').text('-');
                                $('#deposit_btn').attr('disabled', true);
                                $('#error_amount').text(data.message_min_amount);
                            }
                            else
                            {
                                $('#amount-usd').text('-');
                                $('#deposit_btn').attr('disabled', true);
                                $('#error_amount').text('');
                            }
                            return;
                        }

                        if(!data.deposit_info.is_depositable)
                        {
                            $('#amount-usd').text(data.deposit_rate.data.toAmount);
                            $('#deposit_btn').attr('disabled', true);
                            if (data.deposit_info.is_simple_member)
                            {
                                $('#error_amount').text(data.message_simple_limit);
                            }
                            else
                            {
                                $('#error_amount').text(data.message_annual_limit);
                            }

                            return;
                        }

                        if(krw >= 50000 && krw <= 5000000)
                        {
                            $('#amount-usd').text('$' + data.deposit_rate.data.toAmount);
                            if (data.deposit_info.is_simple_member && !data.deposit_info.is_depositable) {
                                $('#deposit_btn').attr('disabled', true);
                                $('#error_amount').text(data.message_simple_limit);
                            } else {
                                $('#deposit_btn').attr('disabled', false);
                                $('#error_amount').text('');
                            }
                            return;
                        }
                        else if(krw < 50000)
                        {
                            $('#amount-usd').text('-');
                            $('#deposit_btn').attr('disabled', true);
                            $('#error_amount').text(data.message_min_amount);
                            return;
                        }
                        else
                        {
                            $('#amount-usd').text('-');
                            $('#deposit_btn').attr('disabled', true);
                            $('#error_amount').text(data.message_max_amount);
                            return;
                        }
                    },
                });
            }, 300);
        },

        openUtransferUrl: function(e) {
            e.preventDefault();
            const url = $('#ut-kyc-btn').attr('href');
            $('#utransfer-iframe').attr('src', url);
            $('#local_payment_modal').modal('show');
        }
    });
});
